import { useTranslation, Trans } from "next-i18next";
import parse from "html-react-parser";
import { Docker, K8s, Linux, Windows
} from "../../components/v2/icons";
import AgentIntegration from "../../components/v2/agent-integration";
import Accordion from "../../components/v2/accordion/accordion";
import ProductResources from "../../components/v2/product/product-resource";
import ProductHeroSection from "../../components/v2/common/product-hero";
import ProductTour from "../../components/v2/product/product-tour";
import '../../styles/scss/_faq-section.module.scss';
import ProductOverviewSection from "../../components/v2/product-overview-section";
import FeaturesMonitoringV2 from "../../components/v2/tabs/features-monitoring-v2";
import ClientTabsTestimonials from "../../components/v2/mw-carousel/testimonial-with-tabs";
import CallToActionDocsLink from "../../components/v2/blog/call-to-action-docs-link";
import { APM, Logs, SreAgent, StatusPageLogo, SyntheticLogo } from "../../components/v2/icons-v2";

export default function StatusPage() {
    const { t } = useTranslation("common");

    const featuresData = t('product.status-page.features.detailedFeatures', { returnObjects: true }) as any[]
    const features = Array.isArray(featuresData) ? featuresData : []

    const faqsData = t('product.status-page.faq.questions', { returnObjects: true }) as any[]
    const faqs = Array.isArray(faqsData) ? faqsData : []

    const resourceData = t('product.status-page.resources', { returnObjects: true }) as any[]
    const resource = Array.isArray(resourceData) ? resourceData : []

    const productTourData = t('product.status-page.productTour', { returnObjects: true }) as any

    const agentIntegrationData = t('product.status-page.agentIntegration', { returnObjects: true }) as any

    const agentDeployData = t('product.shared.statusPageAgentDeploy', { returnObjects: true }) as any[]
    const agentDeployArray = Array.isArray(agentDeployData) ? agentDeployData : []

    const agentDeploy = agentDeployArray.map(agent => ({
        ...agent,
        icon: <></>
    }))

    const productOverviewData = {
        title: "Status Page Overview",
        buttons: [
            {
                label: "View Docs",
                link: "https://docs.middleware.io/workflow/status-page/overview",
                className: "ahref-btn primary",
            },
            {
                label: "View Pricing",
                link: "/pricing/",
                className: "ahref-btn secondary",
            },
        ],
        description:
            "With Middleware Status Page, you can create a professional public status page that keeps your customers informed with real-time service health, uptime monitoring, incident updates, and maintenance notifications. Teams can showcase service availability, communicate incidents, manage subscriber notifications, and maintain a complete history of service.",
        worksWellWithTitle: "Works Well With",
        worksWellWith: [
            {
                title: "Synthetic",
                link: "/product/synthetic-monitoring/",
                icon: <SyntheticLogo />
            },
            {
                title: "Alerts",
                link: "/platform/alerts/",
                icon: <StatusPageLogo />
            }
        ],
    };
    
    return (
        <>

            <ProductHeroSection
                title={<h1>{t('product.status-page.hero.title')} <span>{t('product.status-page.hero.titleHighlight')}</span></h1>}
                description={t('product.status-page.hero.description')}
                img={"/images/v2/products/middleware-status-page.webp"}
                imgWidth={1548}
                imgHeight={1180}
                preloadImg
                imgAlt={t('product.status-page.hero.imageAlt')}
                hasActions={true}
                tips={t('product.status-page.hero.tips')}
            />

            <ProductOverviewSection productOverviewData={productOverviewData} />

            <FeaturesMonitoringV2 productFeatures={features} tourId={"status-tour"} />

            <CallToActionDocsLink
                title={'Create a status page with live service health and incident updates.'}
                docsLink="https://docs.middleware.io/workflow/status-page/overview"
            />

            <section className="testimonial-section">
                <div className="container">
                    <div className="section-tag testimonial">{t("testimonials.tag")} 👤</div>
                    <h2>Hear it from the best: Why <span className="text-gradient">top companies</span> trust Middleware</h2>

                    <ClientTabsTestimonials />
                </div>
            </section>

            <AgentIntegration
                agentDeploy={agentDeploy}
                title={
                    <h2>Everything You Need to Launch a <span className="text-gradient">Status Page</span></h2>
                }
                description={"Achieve a live, branded public status page in minutes, no separate monitoring tool or DNS setup required to get started."}
                contactUsVariant="status-page"
                nameClass={"status-page-agent-integration"}
            />

            <ProductResources resources={resource} title={t('product.shared.resources.title')} />

            <section className={"faq-section"}>
                <div className={"container"}>
                    <h2>{t('product.status-page.faq.title')}</h2>
                    <p>{t('product.status-page.faq.subtitle')}</p>
                    <div className={"faq-item"}>
                        <Accordion
                            faqs={faqs.map((faq: { id: number; header: string; text: string; textHtml?: string }) => ({
                                id: faq.id,
                                header: faq.header,
                                answerPlain: faq.text,
                                text:
                                    faq.textHtml != null && faq.textHtml !== ""
                                        ? parse(faq.textHtml)
                                        : <p>{faq.text}</p>,
                            }))}
                            showGroups={true}
                        />
                    </div>
                </div>
            </section>

        </>
    )
}